module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-It.7dfc0e4.ttf";